import { actionTypesView } from './actionTypes'

export const changeViewAction = () => {
    return {
        type: actionTypesView.changeView,
    }
}
